import {
    RETRIEVE_ISSUE_CATEGORY,
    CREATE_ISSUE_CATEGORY,
    UPDATE_ISSUE_CATEGORY
} from "../../actions/types";

const initialState = [];

function issueCategoryReducer(issueCategories = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case RETRIEVE_ISSUE_CATEGORY:
            return payload;
        case CREATE_ISSUE_CATEGORY:
            return [...issueCategories, payload];
        case UPDATE_ISSUE_CATEGORY:
            return issueCategories.map(issueCategory => {
                if (payload.item && issueCategory.id === payload.item.id) {
                    return {...issueCategory, ...payload.item};
                } else {
                    return issueCategory;
                }
            });
        default:
            return issueCategories;
    }
}

export default issueCategoryReducer;